import { useState, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { RMMClient } from '../../../index';
import { GET_POLICY_SET_MAPPING } from '../../../DeviceGraphQL/queries/MDMSettingsPage';
import { useProduct, COMMON_CONSTANTS } from '../../../index';

interface PolicySetMappingData {
  android: any[];
  ios: any[];
  ipados: any[];
  macos: any[];
}

export const usePolicySetMapping = (clientId?: string, classId?: string) => {
  const [policySetMapping, setPolicySetMapping] = useState<
    PolicySetMappingData
  >({
    android: [],
    ios: [],
    ipados: [],
    macos: []
  });

  const isMSPProduct = useProduct(COMMON_CONSTANTS.MSP);

  const [fetchPolicySetMapping, { loading, error }] = useLazyQuery(
    GET_POLICY_SET_MAPPING,
    {
      client: RMMClient,
      fetchPolicy: 'no-cache',
      onCompleted: (res) => {
        if (res?.getPolicySetMapping) {
          setPolicySetMapping(getPolicySetsByClassId(res.getPolicySetMapping));
        }
      }
    }
  );

  function getPolicySetsByClassId(data: any[]) {
    const android: any[] = [];
    const ios: any[] = [];
    const ipados: any[] = [];
    const macos: any[] = [];

    data.forEach((item) => {
      switch (item.policySet.assetClass.classId) {
        case '41': // Android
          android.push(item);
          break;
        case '42': // Apple iOS
          ios.push(item);
          break;
        case '43': // Apple iPadOS
          ipados.push(item);
          break;
        case '3': // Apple macOS
          macos.push(item);
          break;
        default:
          break;
      }
    });

    return { android, ios, ipados, macos };
  }

  const fetchData = async () => {
    try {
      await fetchPolicySetMapping({
        variables: {
          clientId: isMSPProduct ? clientId : null,
          classId
        }
      });
    } catch (err) {
      //
    }
  };

  useEffect(() => {
    fetchData();
  }, [clientId, classId, isMSPProduct]);

  return {
    policySetMapping,
    loading,
    error,
    refetch: fetchData
  };
};
